import SaveIcon from '@mui/icons-material/Save'
import { Box, Divider, Fab, FormControl, FormControlLabel, Grid, Radio, RadioGroup, Tooltip, Typography } from '@mui/material'
import { useSnackbar } from 'notistack'
import { FC, useEffect, useRef, useState } from 'react'
import { CornerCabinetSizesType } from '../../../api/appAPI'
import { EnqueueSnackbarType, showMessage } from '../../common/Helpers'
import { CornerCabinetSize } from '../Category/CornerCategoryUIBox'


interface IProps {
    cabinetSizes: CornerCabinetSizesType

    editCabinetSizes(name: string, value: string, enqueueSnackbar: EnqueueSnackbarType): void
}


const CornerCabinetSizes: FC<IProps> = ({ cabinetSizes, ...props }) => {

    const [sizeProps, setSizeProps] = useState({
        cabinetType: 'base',
        userType: 'retail',
        width1Values: cabinetSizes.base_retail_cornerCabinet_sizes.width1.values,
        width2Values: cabinetSizes.base_retail_cornerCabinet_sizes.width2.values,
        heightValues: cabinetSizes.base_retail_cornerCabinet_sizes.height.values,
        depth1Values: cabinetSizes.base_retail_cornerCabinet_sizes.depth1.values,
        depth2Values: cabinetSizes.base_retail_cornerCabinet_sizes.depth2.values,
        backWidth1Values: cabinetSizes.base_retail_cornerCabinet_sizes.backWidth1.values,
        backWidth2Values: cabinetSizes.base_retail_cornerCabinet_sizes.backWidth2.values,
        width1Default: cabinetSizes.base_retail_cornerCabinet_sizes.width1.default,
        width2Default: cabinetSizes.base_retail_cornerCabinet_sizes.width2.default,
        heightDefault: cabinetSizes.base_retail_cornerCabinet_sizes.height.default,
        depth1Default: cabinetSizes.base_retail_cornerCabinet_sizes.depth1.default,
        depth2Default: cabinetSizes.base_retail_cornerCabinet_sizes.depth2.default,
        backWidth1Default: cabinetSizes.base_retail_cornerCabinet_sizes.backWidth1.default,
        backWidth2Default: cabinetSizes.base_retail_cornerCabinet_sizes.backWidth2.default
    })
    const sizePropsRef = useRef(sizeProps)

    const [needSave, setNeedSave] = useState(false)
    const needSaveRef = useRef(needSave)

    const { enqueueSnackbar } = useSnackbar()

    useEffect(() => {
        const needSave = JSON.stringify({
            width1: {
                values: sizeProps.width1Values,
                default: sizeProps.width1Default
            },
            width2: {
                values: sizeProps.width2Values,
                default: sizeProps.width2Default
            },
            backWidth1: {
                values: sizeProps.backWidth1Values,
                default: sizeProps.backWidth1Default
            },
            backWidth2: {
                values: sizeProps.backWidth2Values,
                default: sizeProps.backWidth2Default
            },
            height: {
                values: sizeProps.heightValues,
                default: sizeProps.heightDefault
            },
            depth1: {
                values: sizeProps.depth1Values,
                default: sizeProps.depth1Default
            },
            depth2: {
                values: sizeProps.depth2Values,
                default: sizeProps.depth2Default
            }
            // @ts-ignore
        }) !== JSON.stringify(cabinetSizes[sizeProps.cabinetType + '_' + sizeProps.userType + '_cornerCabinet_sizes'])

        console.log(JSON.stringify({
            width1: {
                values: sizeProps.width1Values,
                default: sizeProps.width1Default
            },
            width2: {
                values: sizeProps.width2Values,
                default: sizeProps.width2Default
            },
            backWidth1: {
                values: sizeProps.backWidth1Values,
                default: sizeProps.backWidth1Default
            },
            backWidth2: {
                values: sizeProps.backWidth2Values,
                default: sizeProps.backWidth2Default
            },
            height: {
                values: sizeProps.heightValues,
                default: sizeProps.heightDefault
            },
            depth1: {
                values: sizeProps.depth1Values,
                default: sizeProps.depth1Default
            },
            depth2: {
                values: sizeProps.depth2Values,
                default: sizeProps.depth2Default
            }
        }))

        // @ts-ignore
        console.log(JSON.stringify(cabinetSizes[sizeProps.cabinetType + '_' + sizeProps.userType + '_cornerCabinet_sizes']))

        setNeedSave(needSave)

        sizePropsRef.current = sizeProps
        needSaveRef.current = needSave
    })

    useEffect(() => {
        setAllValues()
    }, [cabinetSizes, sizeProps.userType, sizeProps.cabinetType])


    useEffect(() => () => {
        if (needSaveRef.current) {
            if (window?.confirm('Save changes?')) {
                onSaveClick()
            }
        }
    }, [])

    const setAllValues = () => {
        setSizeProps({
            ...sizeProps,
            // @ts-ignore
            width1Values: cabinetSizes[sizeProps.cabinetType + '_' + sizeProps.userType + '_cornerCabinet_sizes'].width1.values,
            // @ts-ignore
            width2Values: cabinetSizes[sizeProps.cabinetType + '_' + sizeProps.userType + '_cornerCabinet_sizes'].width2.values,
            // @ts-ignore
            width1Default: cabinetSizes[sizeProps.cabinetType + '_' + sizeProps.userType + '_cornerCabinet_sizes'].width1.default,
            // @ts-ignore
            width2Default: cabinetSizes[sizeProps.cabinetType + '_' + sizeProps.userType + '_cornerCabinet_sizes'].width2.default,
            // @ts-ignore
            heightValues: cabinetSizes[sizeProps.cabinetType + '_' + sizeProps.userType + '_cornerCabinet_sizes'].height.values,
            // @ts-ignore
            heightDefault: cabinetSizes[sizeProps.cabinetType + '_' + sizeProps.userType + '_cornerCabinet_sizes'].height.default,
            // @ts-ignore
            depth1Values: cabinetSizes[sizeProps.cabinetType + '_' + sizeProps.userType + '_cornerCabinet_sizes'].depth1.values,
            // @ts-ignore
            depth2Values: cabinetSizes[sizeProps.cabinetType + '_' + sizeProps.userType + '_cornerCabinet_sizes'].depth2.values,
            // @ts-ignore
            depth1Default: cabinetSizes[sizeProps.cabinetType + '_' + sizeProps.userType + '_cornerCabinet_sizes'].depth1.default,
            // @ts-ignore
            depth2Default: cabinetSizes[sizeProps.cabinetType + '_' + sizeProps.userType + '_cornerCabinet_sizes'].depth2.default,
            // @ts-ignore
            backWidth1Values: cabinetSizes[sizeProps.cabinetType + '_' + sizeProps.userType + '_cornerCabinet_sizes'].backWidth1.values,
            // @ts-ignore
            backWidth2Values: cabinetSizes[sizeProps.cabinetType + '_' + sizeProps.userType + '_cornerCabinet_sizes'].backWidth2.values,
            // @ts-ignore
            backWidth1Default: cabinetSizes[sizeProps.cabinetType + '_' + sizeProps.userType + '_cornerCabinet_sizes'].backWidth1.default,
            // @ts-ignore
            backWidth2Default: cabinetSizes[sizeProps.cabinetType + '_' + sizeProps.userType + '_cornerCabinet_sizes'].backWidth2.default
        })
    }

    const onSaveClick = () => {

        const cabinetType = sizePropsRef.current.cabinetType
        const userType = sizePropsRef.current.userType
        const width1Values = sizePropsRef.current.width1Values
        const width2Values = sizePropsRef.current.width2Values
        const width1Default = sizePropsRef.current.width1Default
        const width2Default = sizePropsRef.current.width2Default
        const depth1Values = sizePropsRef.current.depth1Values
        const depth2Values = sizePropsRef.current.depth2Values
        const depth1Default = sizePropsRef.current.depth1Default
        const depth2Default = sizePropsRef.current.depth2Default
        const backWidth1Values = sizePropsRef.current.backWidth1Values
        const backWidth2Values = sizePropsRef.current.backWidth2Values
        const backWidth1Default = sizePropsRef.current.backWidth1Default
        const backWidth2Default = sizePropsRef.current.backWidth2Default
        const heightValues = sizePropsRef.current.heightValues
        const heightDefault = sizePropsRef.current.heightDefault

        if (width1Values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of width1')
            return
        }
        if (width2Values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of width2')
            return
        }

        if (!width1Values.includes(width1Default)) {
            showMessage(enqueueSnackbar, 'Choose default value for width1')
            return
        }
        if (!width2Values.includes(width2Default)) {
            showMessage(enqueueSnackbar, 'Choose default value for width2')
            return
        }

        if (heightValues.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of height')
            return
        }
        if (!heightValues.includes(heightDefault)) {
            showMessage(enqueueSnackbar, 'Choose default value for height')
            return
        }

        if (depth1Values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of depth1')
            return
        }
        if (depth2Values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of depth2')
            return
        }
        if (!depth1Values.includes(depth1Default)) {
            showMessage(enqueueSnackbar, 'Choose default value for depth1')
            return
        }
        if (!depth2Values.includes(depth2Default)) {
            showMessage(enqueueSnackbar, 'Choose default value for depth2')
            return
        }

        if (backWidth1Values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of back width1')
            return
        }
        if (backWidth2Values.length === 0) {
            showMessage(enqueueSnackbar, 'Write at least one value of back width2')
            return
        }
        if (!backWidth1Values.includes(backWidth1Default)) {
            showMessage(enqueueSnackbar, 'Choose default value for back width1')
            return
        }
        if (!backWidth2Values.includes(backWidth2Default)) {
            showMessage(enqueueSnackbar, 'Choose default value for back width2')
            return
        }

        needSaveRef.current = false
        setNeedSave(false)

        props.editCabinetSizes(
            cabinetType + '_' + userType + '_cornerCabinet_sizes',
            JSON.stringify({
                width1: {
                    values: width1Values,
                    default: width1Default
                },
                width2: {
                    values: width2Values,
                    default: width2Default
                },
                backWidth1: {
                    values: backWidth1Values,
                    default: backWidth1Default
                },
                backWidth2: {
                    values: backWidth2Values,
                    default: backWidth2Default
                },
                height: {
                    values: heightValues,
                    default: heightDefault
                },
                depth1: {
                    values: depth1Values,
                    default: depth1Default
                },
                depth2: {
                    values: depth2Values,
                    default: depth2Default
                }
            }),
            enqueueSnackbar
        )
    }

    return (
        <Box
            display='flex'
            flexDirection='column'
            alignItems='center'
            pb={2}
            style={{
                width: 400,
                height: 'fit-content',
                margin: 15,
                border: '1px solid black',
                maxHeight: '90%',
                overflowY: 'auto',
                overflowX: 'hidden',
                position: 'relative'
            }}
        >
            <Box
                py={1}
                style={{
                    position: 'sticky',
                    top: 0,
                    width: '100%',
                    backgroundColor: 'white',
                    zIndex: 10
                }}>
                <Grid container spacing={2}>
                    <Grid item xs={3}> </Grid>
                    <Grid item xs={6} container justifyContent='center' alignItems='center'>
                        <Typography variant='h6'>Edit Cabinet Sizes</Typography>
                    </Grid>
                    <Grid item xs={3} container justifyContent='flex-end' alignItems='center'>
                        <Tooltip title='Save'>
                            <Fab
                                color={needSave ? 'secondary' : "primary"}
                                size='small'
                                onClick={onSaveClick}
                                style={{ marginRight: 10 }}
                            >
                                <SaveIcon />
                            </Fab>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Box>


            <FormControl component="fieldset">
                <RadioGroup row
                    value={sizeProps.cabinetType}
                    onChange={e => {
                        if (needSave) {
                            if (window?.confirm('Save changes?')) {
                                onSaveClick()
                            }
                        }

                        setSizeProps({ ...sizeProps, cabinetType: e.target.value })
                    }}
                >
                    <FormControlLabel value="base" control={<Radio color='primary' />} label="Base" />
                    <FormControlLabel value="tall" control={<Radio color='primary' />} label="Tall" />
                    <FormControlLabel value="upper" control={<Radio color='primary' />} label="Upper" />
                </RadioGroup>
            </FormControl>

            <FormControl component="fieldset">
                <RadioGroup row
                    value={sizeProps.userType}
                    onChange={e => {
                        if (needSave) {
                            if (window?.confirm('Save changes?')) {
                                onSaveClick()
                            }
                        }

                        setSizeProps({ ...sizeProps, userType: e.target.value })
                    }}
                >
                    <FormControlLabel value="retail" control={<Radio color='primary' />} label="Retail" />
                    <FormControlLabel value="dealer" control={<Radio color='primary' />} label="Dealer" />
                    <FormControlLabel value="designer" control={<Radio color='primary' />} label="Designer" />
                </RadioGroup>
            </FormControl>


            <CornerCabinetSize
                name='Height' values={sizeProps.heightValues} defaultValue={sizeProps.heightDefault}
                setValues={(v: number[]) => { setSizeProps({ ...sizeProps, heightValues: v }) }}
                setDefaultValue={(v: number) => { setSizeProps({ ...sizeProps, heightDefault: v }) }}
            />
            <CornerCabinetSize
                name='Width 1' values={sizeProps.width1Values} defaultValue={sizeProps.width1Default}
                setValues={(v: number[]) => { setSizeProps({ ...sizeProps, width1Values: v }) }}
                setDefaultValue={(v: number) => { setSizeProps({ ...sizeProps, width1Default: v }) }}
            />
            <CornerCabinetSize
                name='Width 2' values={sizeProps.width2Values} defaultValue={sizeProps.width2Default}
                setValues={(v: number[]) => { setSizeProps({ ...sizeProps, width2Values: v }) }}
                setDefaultValue={(v: number) => { setSizeProps({ ...sizeProps, width2Default: v }) }}
            />
            <CornerCabinetSize
                name='Depth 1' values={sizeProps.depth1Values} defaultValue={sizeProps.depth1Default}
                setValues={(v: number[]) => { setSizeProps({ ...sizeProps, depth1Values: v }) }}
                setDefaultValue={(v: number) => { setSizeProps({ ...sizeProps, depth1Default: v }) }}
            />
            <CornerCabinetSize
                name='Depth 2' values={sizeProps.depth2Values} defaultValue={sizeProps.depth2Default}
                setValues={(v: number[]) => { setSizeProps({ ...sizeProps, depth2Values: v }) }}
                setDefaultValue={(v: number) => { setSizeProps({ ...sizeProps, depth2Default: v }) }}
            />
            <CornerCabinetSize
                name='Back Width 1' values={sizeProps.backWidth1Values} defaultValue={sizeProps.backWidth1Default}
                setValues={(v: number[]) => { setSizeProps({ ...sizeProps, backWidth1Values: v }) }}
                setDefaultValue={(v: number) => { setSizeProps({ ...sizeProps, backWidth1Default: v }) }}
            />
            <CornerCabinetSize
                name='Back Width 2' values={sizeProps.backWidth2Values} defaultValue={sizeProps.backWidth2Default}
                setValues={(v: number[]) => { setSizeProps({ ...sizeProps, backWidth2Values: v }) }}
                setDefaultValue={(v: number) => { setSizeProps({ ...sizeProps, backWidth2Default: v }) }}
            />

            <Divider style={{ width: '80%', marginTop: 15, marginBottom: 5 }} />

        </Box>
    )
}

export default CornerCabinetSizes